module.exports = __webpack_public_path__ + "img/prostye-zvonki.png";